import { Controller } from "@hotwired/stimulus";
import { recordRecentHomeDestination } from "../../Home/HomeStorage";
import { smartGuideFrontendSettings } from "../webTranslations";

export default class SmartGuideRecentGuideController extends Controller<HTMLElement> {
    connect(): void {
        if (smartGuideFrontendSettings.integrationId) {
            return;
        }

        recordRecentHomeDestination({
            id: this.element.dataset.homeRecentDestinationId ?? "",
            title: this.element.dataset.homeRecentDestinationTitle ?? "",
            url: this.element.dataset.homeRecentDestinationUrl ?? "",
            imageUrl: this.element.dataset.homeRecentDestinationImageUrl ?? null,
            kind: this.element.dataset.homeRecentDestinationKind ?? null,
            logoUrl: this.element.dataset.homeRecentDestinationLogoUrl ?? null
        });
    }
}
